"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Headline = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const Headline = exports.Headline = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['maxLines'])
})(({
  theme,
  maxLines
}) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
  maxWidth: 'none',
  width: '100%',
  display: '-webkit-box',
  WebkitLineClamp: maxLines,
  lineClamp: maxLines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    maxWidth: 860
  }
}));
